import React, { useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

const faqsData = [
  {
    id: 1,
    question: "How do I reset my password?",
    answer:
      "Use the Forgot Password option on the sign-in page, then complete the reset flow from your email link/code. If you are already signed in and need account-level help, create a support case from this page.",
  },
  {
    id: 2,
    question: "How do I report a bug?",
    answer:
      "Open Help & Support > Contact Support, create a case, and include clear reproduction steps, expected behavior, actual behavior, and any related ticket message attachments.",
  },
  {
    id: 3,
    question: "How can I change my notification preferences?",
    answer:
      "Go to the Notifications page from the main navigation to update your notification settings. Changes are saved in your account configuration.",
  },
  {
    id: 4,
    question: "How can I manage users and delivery settings?",
    answer:
      "Open User Management to add/edit users, assign roles, set timezone, and configure SMS preferences. For payment or billing updates, use the Billing section.",
  },
  {
    id: 5,
    question: "How long will it take to get a response?",
    answer:
      "Support requests are typically reviewed within 24 hours on business days. You can track updates directly in Your Cases and reply in the case thread.",
  },
];

const FAQs = () => {
  const [openFaq, setOpenFaq] = useState(1);

  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  return (
    <div className="bg-white border border-line rounded-xl p-4 sm:p-6">
      <h2 className="text-lg font-bold text-primary mb-4">FAQs</h2>

      <div className="space-y-3">
        {faqsData.map((faq) => (
          <div
            key={faq.id}
            className="border border-line rounded-lg overflow-hidden hover:bg-gray-50"
            onClick={() => toggleFaq(faq.id)}
          >
            <button
              className="w-full px-4 sm:px-5 py-4 flex items-center justify-between text-left transition-all duration-500 "
            >
              <span className="text-sm font-semibold text-primary">
                Q{faq.id}: {faq.question}
              </span>
              {openFaq === faq.id ? (
                <RemoveCircleOutlineIcon
                  className="text-muted flex-shrink-0"
                  style={{ fontSize: "1.25rem" }}
                />
              ) : (
                <AddCircleOutlineIcon
                  className="text-muted flex-shrink-0"
                  style={{ fontSize: "1.25rem" }}
                />
              )}
            </button>
            <div
              className={`transition-all duration-300 ease-in-out overflow-hidden ${
                openFaq === faq.id ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <div className="px-5 pb-4">
                <p className="text-sm text-primary leading-relaxed">
                  A: {faq.answer}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQs;
